import { render } from "./ClinicalPatientType.component.vue?vue&type=template&id=a563d662&scoped=true"
import script from "./ClinicalPatientType.component.vue?vue&type=script&lang=js"
export * from "./ClinicalPatientType.component.vue?vue&type=script&lang=js"

import "./ClinicalPatientType.component.vue?vue&type=style&index=0&id=a563d662&scoped=true&lang=css"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a563d662"],['__file',"src/components/clinical/ClinicalPatientType.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a563d662"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a563d662', __exports__)) {
    console.log('reload')
    api.reload('a563d662', __exports__)
  }
  
  module.hot.accept("./ClinicalPatientType.component.vue?vue&type=template&id=a563d662&scoped=true", () => {
    console.log('re-render')
    api.rerender('a563d662', render)
  })

}


export default __exports__